export class ActionPlaceholder {
    /**
     *
     * @param  {CustomizedGUIActionInfo} customization
     */
    constructor(id, customization) {
        this.id = id;
        this.customization = customization;
    }

    /**
     *
     * @return {NaMaText}
     */
    getTitle() {
        return this.title;
    }

    setTitle(title) {
        this.title = title;
    }

    getId() {
        return this.id;
    }

    setId(id) {
        this.id = id;
    }

    isEmpty() {
        return !this.getCustomization().urlTemplate && !this.getCustomization().query && !this.getCustomization().notificationId && !this.getCustomization().entityFlowId && !this.getCustomization().reportInfo.reportId;
    }

    /**
     *
     * @return {CustomizedGUIActionInfo}
     */
    getCustomization() {
        if (!this.customization)
            this.customization = {};
        if (!this.customization.reportInfo)
            this.customization.reportInfo = {};
        return this.customization;
    }

    setCustomization(customization) {
        this.customization = customization;
    }

    /**
     *
     * @return {boolean}
     */
    shouldBeAdded() {
        return this.id !== null || this.customization !== null;
    }
}

export function of(id, customization) {
    return new ActionPlaceholder(id, customization);
}